import SpinerLoader from "../../../components/SpinerLoader";
import { useHistory } from "../api/getHistory";
import HistoricalTable from "../components/HistoricalTable";
import { useHeaderHistory } from "../api/getHeaderHistory";
import { useEffect, useState } from "react";
import SurveyDetail from "../components/SurveyDetail";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { setCurrentPage } from "../../../redux/historicalSlice";
import { setHideFilter } from "../../../redux/filtersSlice";
import NoData from "../../../components/NoData";
import AlertMessage from "../../../components/AlertMessage";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import type { DashboardOutletContext } from "../../../components/Layouts/GlobalDashboardLayout";
import { useTranslation } from "react-i18next";
import { useSurvey } from "../hooks/useSurvey";

export default function Historical() {
	const navigate = useNavigate()
	
	const { t } = useTranslation();
	const [orderBy, setOrderBy] = useState<string>('');
	const [orderDirection, setOrderDirection] = useState<'asc' | 'desc'>('asc');
	const [selectedSurveyId, setSelectedSurveyId] = useState<number | null>(null)
	const selectedFilters = useSelector((state: RootState) => state.filters.dashboard.selectedFilters);
	
    const [searchParams] = useSearchParams();
    const from = searchParams.get('from');
    const surveyId = searchParams.get('survey');

	const { section1Ref, setShowNavigation } = useOutletContext<DashboardOutletContext>();

	const dispatch = useDispatch();
	const currentPage = useSelector((state: RootState) => state.historical.historicalData.currentPage);
	const itemsPerPage = useSelector((state: RootState) => state.historical.historicalData.itemsPerPage);

	const { data: survey, isFetched } = useSurvey({ surveyId: selectedSurveyId });
	const { data: historicalHeader, isLoading: isLoadingHeader } = useHeaderHistory();
	const { data: historicalData, isLoading: isLoadingData, refetch: refetchHistoricalData, isFetching: isFetchingHistoricalData } = useHistory({
		pageNumber: currentPage,
		orderByField: orderBy,
		orderDirection,
	});

	const handleOrderChange = (column: string) => {
		const newOrderDirection = orderBy === column && orderDirection === 'asc' ? 'desc' : 'asc';
		setOrderBy(column);
		setOrderDirection(newOrderDirection);
		dispatch(setCurrentPage({ table: "historicalData", page: 1 }));
	}

	const handleGoToDetails = (surveyId: number) => {
		setSelectedSurveyId(surveyId);
	}
		useEffect(() => {
			if (isFetched) {
				dispatch(setHideFilter({ table: "dashboard", hide: true }));
				setShowNavigation(false);
			}

	}, [isFetched, setShowNavigation])

	useEffect(() => {
		refetchHistoricalData()
	}, [currentPage, orderBy, orderDirection, refetchHistoricalData, itemsPerPage, selectedFilters])

    useEffect(() => {
        if (!surveyId)
            return;

        setSelectedSurveyId(parseInt(surveyId));
    }, [surveyId])

	const location = useLocation();

  	const handleGoBack = () => {
		if (from == 'alert') {
            navigate(`/alertes?survey=${surveyId}`);
		} else {
			setSelectedSurveyId(null);
			dispatch(setHideFilter({table: "dashboard", hide: false}));
			setShowNavigation(true);
			refetchHistoricalData();
		}
  	}

  	return (
		<>
			{location.state?.message && (
				<AlertMessage
					message={location.state?.message}
					type='success'
					displayTime={5000}
				/>
			)}
			{survey 
				? <SurveyDetail survey={survey} onGoBackClick={handleGoBack} /> :
				(isLoadingHeader || isLoadingData || isFetchingHistoricalData) ?
					<div className="align-content-center" style={{minHeight: 620} }>
					<SpinerLoader />
					</div>
				: historicalHeader && historicalData?.surveyHistoryFields?.length 
					? <div ref={section1Ref} className="dashboard-section">
					<HistoricalTable
						historyHeader={historicalHeader}
						historyData={historicalData.surveyHistoryFields}
						onOrderChange={handleOrderChange}
						currentPage={currentPage}
						pageSize={itemsPerPage}
						orderBy={orderBy}
						orderDirection={orderDirection}
						totalPages={historicalData.totalPages}
						goToDetails={handleGoToDetails}
					/>
					</div>
					: <NoData message={t("NoDataFound")} />
			}
		</>
  	);
}